/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-await-in-loop */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { FileExcelOutlined } from '@ant-design/icons';
import {
  ActionIcon,
  Badge,
  Center,
  Grid,
  Group,
  Loader,
  Table as MantineTable,
  Paper,
  Space,
  Tooltip,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';
import { Table } from 'antd';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import lodash from 'lodash';
import { useEffect, useState } from 'react';
import {
  BillingStatement,
  BillingSummary,
  // buildSummaryData,
  buildConsolidatedSummaryData,
  buildStatementData,
  Statement,
} from '../../../../../../../business/events/billing';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import PageViewProperty from '../../../../../../../components/core/PageViewProperty/PageViewProperty';
import ProfileCardLink from '../../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import useCurrentUser from '../../../../../../../hooks/useCurrentUser';
import { MovementBillingType, MovementBillingTypeCode } from '../../../../../../../models/core/cache.type';
import { Permission } from '../../../../../../../models/core/departments.type';
import { EventType } from '../../../../../../../models/core/events.type';
import eventsService from '../../../../../../../services/core/events.service';
import theme from '../../../../../../../theme';
import { Feature } from '../../../../../../../utils/constants.utils';
import { formatCurrency, formatDateToString } from '../../../../../../../utils/formatter.utils';
import { validate } from '../../../../../../../utils/permission.utils';

type DataViewProps = {
  eventoIds: number[];
};

type DataResult = {
  loading: boolean;
  data: EventType[];
  summary: BillingSummary[];
};

export default function MultiBillingStatementView(props: DataViewProps) {
  const [currentUser] = useCurrentUser();

  const [dataResult, setDataResult] = useState<DataResult>({
    loading: true,
    data: [],
    summary: [],
  });

  const groupStatements = (statements: Statement[]) => {
    const pairs = statements.flatMap((stmt) => [
      { clienteFornecedor: stmt.cliente.idEntidade, stmt },
      { clienteFornecedor: stmt.fornecedor.idEntidade, stmt },
    ]);

    const grouped = lodash.groupBy(pairs, 'clienteFornecedor');

    return Object.entries(grouped).map(([clienteFornecedor, entries]) => ({
      clienteFornecedor,
      cliente: [entries[0].stmt.cliente, entries[0].stmt.fornecedor].find(
        (x) => Number(x.idEntidade) === Number(clienteFornecedor)
      )!,
      extrato: lodash.uniqBy(
        entries.map((e) => e.stmt),
        'key'
      ),
    }));
  };

  const populateAndDownload = async (billingSummary: BillingSummary) => {
    const templatePath = `${process.env.PUBLIC_URL}/templates/fechamento_consolidado.xlsx?v=${Date.now()}`;
    const { clienteFornecedor } = billingSummary;

    const response = await fetch(templatePath);
    const buffer = await response.arrayBuffer();

    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);
    workbook.creator = 'Performa Manager';
    workbook.lastModifiedBy = 'Performa Manager';
    workbook.created = new Date();
    workbook.modified = new Date();
    const worksheet = workbook.worksheets[0];

    const populateHeader = () => {
      let row = worksheet.getRow(3);
      row.getCell(9).value =
        clienteFornecedor.nomeFantasia || clienteFornecedor.razaoSocial || clienteFornecedor.nome;
      row.commit();

      row = worksheet.getRow(4);
      row.getCell(9).value = clienteFornecedor.cnpj || clienteFornecedor.cpf;
      row.commit();

      row = worksheet.getRow(5);
      row.getCell(9).value = '-';
      row.commit();
    };

    const populateHeaderBalance = (revenueFormula: string, expenseFormula: string) => {
      let row = worksheet.getRow(3);
      row.getCell(18).value = { formula: expenseFormula };
      row.commit();

      row = worksheet.getRow(4);
      row.getCell(18).value = { formula: revenueFormula };
      row.commit();
    };

    const populateItems = () => {
      const initRowIndex = 10;
      let rowIndex = initRowIndex;
      const styledRow = worksheet.getRow(initRowIndex);
      let hasData = false;

      for (const extrato of billingSummary.extrato) {
        const { residuo, servico, documentos, medicao, cliente, fornecedor, movimentacao, cotacao } = extrato;
        hasData = true;

        let quantidadeMedicao = medicao.quantidadeDestino || medicao.quantidadeOrigem || 1;
        if ((residuo?.minimoAceitavel ?? 0) > 0) {
          quantidadeMedicao =
            quantidadeMedicao < residuo!.minimoAceitavel! ? residuo!.minimoAceitavel! : quantidadeMedicao;
        }

        const newRow = worksheet.insertRow(rowIndex + 1, [
          null,
          residuo?.residuoCliente || servico?.servico, // RESÍDUO / SERVIÇO
          `${extrato.descricao} (${extrato.item})`, // DESCRIÇÃO
          formatDateToString(extrato.data), // DATA
          documentos?.find((x) => x.documentoTipo === 'Nota Fiscal')?.numeroDocumento ?? '', // NF GERADOR
          documentos?.find((x) => x.documentoTipo === 'MTR')?.numeroDocumento ?? '', // MTR
          medicao.quantidadeOrigem ?? '', // QTD ORIG
          medicao.quantidadeDestino ?? '', // QTD DEST
          residuo?.minimoAceitavel ?? '', // QTD MIN
          medicao.quantidadeOrigemUnidadeMedidaSigla ?? '', // UNIDADE
          cliente.nomeFantasia || cliente.razaoSocial || cliente.nome || '', // GERADOR NOME
          cliente.cnpj || cliente.cpf || '', // GERADOR CNPJ/CPF
          movimentacao.receita
            ? movimentacao.receita /
              Math.max(medicao.quantidadeOrigem ?? -1, residuo?.minimoAceitavel ?? -1, 1)
            : '', // GERADOR PREÇO
          movimentacao.receita, // GERADOR RECEITA
          fornecedor.nomeFantasia || fornecedor.razaoSocial || fornecedor.nome || '', // FORNECEDOR NOME
          fornecedor.cnpj || fornecedor.cpf || '', // FORNECEDOR CNPJ/CPF
          cotacao.preco || '', // FORNECEDOR PREÇO
          movimentacao.despesa, // FORNECEDOR DESPESA
        ]);

        newRow.eachCell((cell, colNumber) => {
          cell.style = { ...styledRow.getCell(colNumber).style };
        });
        rowIndex++;
      }

      if (hasData) {
        worksheet.spliceRows(initRowIndex, 1);

        const row = worksheet.getRow(rowIndex);
        row.getCell(7).value = {
          formula: `=SUM(G${initRowIndex}:G${rowIndex - 1})`,
        };
        row.getCell(8).value = {
          formula: `=SUM(H${initRowIndex}:H${rowIndex - 1})`,
        };
        row.getCell(14).value = {
          // formula: `=SUM(M${initRowIndex}:M${rowIndex - 1})`,
          formula: `=SUMIF(L${initRowIndex}:L${rowIndex - 1},$I$4,N${initRowIndex}:N${rowIndex - 1})`,
        };
        row.getCell(18).value = {
          // formula: `=SUM(P${initRowIndex}:P${rowIndex - 1})`,
          formula: `=SUMIF(P${initRowIndex}:P${rowIndex - 1},$I$4,R${initRowIndex}:R${rowIndex - 1})`,
        };
      } else {
        rowIndex++;
      }

      return { rowIndex, colTotalRevenue: 'N', colTotalExpense: 'R' };
    };

    const autoFitColumns = (finalRowIndex: number) => {
      for (let col = 2; col <= 12; col++) {
        // Columns B (2) to L (12)
        let maxLength = 0;

        for (let row = 1; row <= finalRowIndex; row++) {
          const cell = worksheet.getRow(row).getCell(col);
          const cellLength = cell.value ? cell.toString().length : 0;
          maxLength = Math.max(maxLength, cellLength);
        }

        worksheet.getColumn(col).width = maxLength + 5;
      }
    };

    populateHeader();
    const excelResponse = populateItems();

    populateHeaderBalance(
      `${excelResponse.colTotalExpense}${excelResponse.rowIndex}`,
      `${excelResponse.colTotalRevenue}${excelResponse.rowIndex}`
    );

    autoFitColumns(excelResponse.rowIndex);

    const excelBuffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(
      blob,
      `Fechamento_Consolidado_${(
        billingSummary.clienteFornecedor.cnpj ||
        billingSummary.clienteFornecedor.cpf ||
        ''
      ).replace(/\D+/g, '')}_${new Date().valueOf()}.xlsx`
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      let eventData: EventType[] = [];
      try {
        eventData = await Promise.all(
          props.eventoIds.map((id) => eventsService.select({ idEvento: Number(id) }))
        );
        eventData = eventData.filter((event) => event.faturamento); // Filter out any undefined or null events

        // const batchSize = 5;
        // for (let i = 0; i < props.eventoIds.length; i += batchSize) {
        //   const batch = props.eventoIds.slice(i, i + batchSize);
        //   const results = await Promise.all(
        //     batch.map((id) => eventsService.select({ idEvento: Number(id) }))
        //   );
        //   eventData.push(...results);
        // }

        const statements: BillingStatement[] = [];
        const summaries: BillingSummary[] = [];
        for (const event of eventData) {
          statements.push(buildStatementData(event));
        }

        const mergedStatements = groupStatements(statements.flatMap((statement) => statement.extrato));
        for (const statement of mergedStatements) {
          const client =
            eventData.findIndex((e) => e.resumoJSON?.cliente?.idCliente === statement.cliente.idEntidade) >
            -1;

          if (statement.cliente.idEntidade > 0) {
            summaries.push(
              buildConsolidatedSummaryData(
                {
                  cliente: statement.cliente,
                  extrato: statement.extrato,
                },
                client
              )
            );
          }
        }

        setDataResult({
          loading: false,
          data: eventData,
          summary: summaries,
        });
      } catch (err: any) {
        showNotification({
          title: `Fechamento Geral`,
          message: err?.isBusinessException ? err.description : 'Não foi possível carregar o(s) evento(s).',
          color: 'red',
        });
      }
    };

    if (!validate(Permission.EventView, currentUser.permissoes)) {
      window.location.href = '/403';
      return;
    }
    fetchData();
  }, []);

  return (
    <div>
      {dataResult.loading ? (
        <Center>
          <Loader size="xl" />
        </Center>
      ) : (
        <div>
          <Paper shadow="xs" p="md" withBorder>
            <Group justify="space-between">
              <PageSection
                size="lg"
                color={Feature.Home.Event.color}
                label="Faturamento Geral"
                text="Lista consolidada de todas as movimentações associadas à essa(s) entidades(s)."
              />
            </Group>
            <Space h="xs" />

            <Table
              showSorterTooltip={false}
              dataSource={dataResult.summary}
              columns={[
                {
                  title: 'Entidade',
                  key: 'entidade',
                  sorter: (a: BillingSummary, b: BillingSummary) => {
                    const aValue =
                      a.clienteFornecedor.nomeFantasia ||
                      a.clienteFornecedor.razaoSocial ||
                      a.clienteFornecedor.nome ||
                      '-';
                    const bValue =
                      b.clienteFornecedor.nomeFantasia ||
                      b.clienteFornecedor.razaoSocial ||
                      b.clienteFornecedor.nome ||
                      '-';
                    return aValue.localeCompare(bValue);
                  },
                  render: (row: BillingSummary) => {
                    if (!row.clienteFornecedor.idEntidade) {
                      return '-';
                    }
                    return row.clienteFornecedor.cnpj ? (
                      <ProfileCardLink
                        id={row.clienteFornecedor.idEntidade.toString()}
                        name={row.clienteFornecedor.nomeFantasia || row.clienteFornecedor.razaoSocial || '-'}
                        nameSize="sm"
                        description={
                          row.clienteFornecedor.nomeFantasia
                            ? row.clienteFornecedor.razaoSocial
                            : row.clienteFornecedor.cnpj
                        }
                        descriptionSize="xs"
                        linkPrefix="entities"
                        showLink
                      />
                    ) : (
                      <ProfileCardLink
                        id={row.clienteFornecedor.idEntidade.toString()}
                        name={row.clienteFornecedor.nome || '-'}
                        nameSize="sm"
                        description={row.clienteFornecedor.cpf}
                        descriptionSize="xs"
                        linkPrefix="entities"
                        showLink
                      />
                    );
                  },
                },
                {
                  title: 'Receita',
                  key: 'receita',
                  sorter: (a: BillingSummary, b: BillingSummary) => {
                    const aValue = a.receita || 0;
                    const bValue = b.receita || 0;
                    if (aValue === bValue) {
                      return 0;
                    }
                    return aValue > bValue ? 1 : -1;
                  },
                  render: (row: BillingSummary) => <div>{formatCurrency(row.receita)}</div>,
                },
                {
                  title: 'Despesa',
                  key: 'despesa',
                  sorter: (a: BillingSummary, b: BillingSummary) => {
                    const aValue = a.despesa || 0;
                    const bValue = b.despesa || 0;
                    if (aValue === bValue) {
                      return 0;
                    }
                    return aValue > bValue ? 1 : -1;
                  },
                  render: (row: BillingSummary) => <div>{formatCurrency(row.despesa)}</div>,
                },
                {
                  title: 'Balanço',
                  key: 'balanco',
                  sorter: (a: BillingSummary, b: BillingSummary) => {
                    const aValue = a.balanco;
                    const bValue = b.balanco;
                    if (aValue === bValue) {
                      return 0;
                    }
                    return aValue > bValue ? 1 : -1;
                  },
                  render: (row: BillingSummary) => {
                    const total = row.balanco;
                    const color = total > 0 ? 'green' : total === 0 ? 'orange' : 'red';

                    return (
                      <div style={{ color }}>{`${formatCurrency(total)} (${
                        row.balanco > 0 ? 'Recebimento' : 'Pagamento'
                      })`}</div>
                    );
                  },
                },
                {
                  title: 'Encontro de Contas?',
                  key: 'aceitaEncontroContas',
                  sorter: (a: BillingSummary, b: BillingSummary) =>
                    a.clienteFornecedor.aceitaEncontroContas === b.clienteFornecedor.aceitaEncontroContas
                      ? 0
                      : a.clienteFornecedor.aceitaEncontroContas
                      ? -1
                      : 1,
                  render: (row: BillingSummary) => (
                    <div>
                      {row.clienteFornecedor.aceitaEncontroContas ? (
                        <IconCheck color="green" />
                      ) : (
                        <IconX color="red" />
                      )}
                    </div>
                  ),
                },
                {
                  title: 'Ações',
                  width: '130px',
                  render: (row: BillingSummary) => {
                    return (
                      <Group>
                        {validate(Permission.EventPrint, currentUser.permissoes) ? (
                          <Tooltip
                            withArrow
                            transitionProps={{ transition: 'fade', duration: 200 }}
                            label="Exportar para excel"
                          >
                            <ActionIcon
                              size="sm"
                              radius="sm"
                              color="green"
                              style={{ borderColor: theme?.colors?.dark?.[6] }}
                              variant="outline"
                              onClick={async () => {
                                populateAndDownload(row);
                              }}
                            >
                              <FileExcelOutlined size={15} color={theme?.colors?.green?.[6]} />
                            </ActionIcon>
                          </Tooltip>
                        ) : (
                          '-'
                        )}
                      </Group>
                    );
                  },
                },
              ]}
              rowKey="key"
              expandable={{
                // eslint-disable-next-line react/no-unstable-nested-components
                expandedRowRender: (item) => {
                  return (
                    <Paper shadow="xs" p="md" withBorder>
                      <Paper shadow="xs" p="md" withBorder>
                        <MantineTable withTableBorder withColumnBorders striped>
                          <MantineTable.Thead>
                            <MantineTable.Tr>
                              <MantineTable.Th>Tipo de Faturamento</MantineTable.Th>
                              <MantineTable.Th>Receita</MantineTable.Th>
                              <MantineTable.Th>Despesa</MantineTable.Th>
                              <MantineTable.Th>Balanço</MantineTable.Th>
                            </MantineTable.Tr>
                          </MantineTable.Thead>
                          <MantineTable.Tbody>
                            {item.faturamento.map((x) => {
                              return (
                                <MantineTable.Tr>
                                  <MantineTable.Td>{x.tipo}</MantineTable.Td>
                                  <MantineTable.Td>{formatCurrency(x.receita)}</MantineTable.Td>
                                  <MantineTable.Td>{formatCurrency(x.despesa)}</MantineTable.Td>
                                  <MantineTable.Td
                                    style={{
                                      color: x.balanco > 0 ? 'green' : x.balanco === 0 ? 'orange' : 'red',
                                    }}
                                  >
                                    {`${formatCurrency(x.balanco)} (${
                                      x.balanco > 0 ? 'Recebimento' : 'Pagamento'
                                    })`}
                                  </MantineTable.Td>
                                </MantineTable.Tr>
                              );
                            })}
                          </MantineTable.Tbody>
                        </MantineTable>
                      </Paper>
                      <Space h="lg" />

                      <Paper shadow="xs" p="md" withBorder>
                        <PageSection
                          size="md"
                          color={Feature.Home.Event.color}
                          label="Movimentações"
                          text=""
                        />
                        <Space h="xs" />

                        <Table
                          showSorterTooltip={false}
                          dataSource={item.extrato}
                          // dataSource={item.extrato.filter((x) => x.movimentacao.balanco !== 0)}
                          columns={[
                            {
                              title: 'Evento',
                              key: 'idEventoReferenciado',
                              sorter: (a: Statement, b: Statement) => {
                                const aValue = a.idEvento;
                                const bValue = b.idEvento;
                                if (aValue === bValue) {
                                  return 0;
                                }
                                return aValue > bValue ? 1 : -1;
                              },
                              render: (row: Statement) => {
                                return (
                                  <ProfileCardLink
                                    id={row.idEvento.toString()}
                                    name={`# ${row.idEvento}`}
                                    nameSize="sm"
                                    avatar="E"
                                    description={`${row.eventoTipo}`}
                                    descriptionSize="xs"
                                    linkPrefix="events"
                                    showLink
                                  />
                                );
                              },
                            },
                            {
                              title: 'Resíduo / Serviço',
                              key: 'receita',
                              sorter: (a: Statement, b: Statement) =>
                                (a.residuo?.residuoCliente || a.servico?.servico || '-').localeCompare(
                                  b.residuo?.residuoCliente || b.servico?.servico || '-'
                                ),
                              render: (row: Statement) => {
                                return row.residuo ? (
                                  <ProfileCardLink
                                    id={row.residuo.idResiduo.toString()}
                                    name={row.residuo.residuoCliente}
                                    nameSize="sm"
                                    description={`Código IBAMA: ${
                                      row.residuo.codigoIBAMA || '-'
                                    } | Perigoso: ${row.residuo.residuoClientePerigoso ? 'Sim' : 'Não'}`}
                                    descriptionSize="xs"
                                    descriptionLength={100}
                                    linkPrefix="residues"
                                    avatar="R"
                                    showLink
                                  />
                                ) : row.servico ? (
                                  <ProfileCardLink
                                    id={row.servico!.idServico.toString()}
                                    name={row.servico!.servico}
                                    nameSize="sm"
                                    description={row.servico!.servicoDescricao}
                                    descriptionSize="xs"
                                    linkPrefix="services"
                                    avatar="S"
                                    showLink
                                  />
                                ) : (
                                  '-'
                                );
                              },
                            },
                            {
                              title: 'Descrição',
                              key: 'descricao',
                              sorter: (a: Statement, b: Statement) => a.descricao.localeCompare(b.descricao),
                              render: (row: Statement) => {
                                return (
                                  <ProfileCardLink
                                    id={row.movimentacao.idEventoMedicaoMovimentacao?.toString() || '-'}
                                    name={row.descricao}
                                    nameSize="sm"
                                    description={row.item}
                                    descriptionSize="xs"
                                    avatar={
                                      row.grupo === MovementBillingTypeCode.GR
                                        ? MovementBillingType.GerenciamentoResiduo
                                        : row.grupo === MovementBillingTypeCode.LO
                                        ? MovementBillingType.Locacao
                                        : MovementBillingType.PrestacaoServico
                                    }
                                    showLink={false}
                                  />
                                );
                              },
                            },
                            // {
                            //   title: 'Documentos',
                            //   key: 'documentos',
                            //   sorter: (a: Statement, b: Statement) => {
                            //     const aValue = (a.documentos || []).length;
                            //     const bValue = (b.documentos || []).length;
                            //     if (aValue === bValue) {
                            //       return 0;
                            //     }
                            //     return aValue > bValue ? 1 : -1;
                            //   },
                            //   render: (item: Statement) => {
                            //     return (item.documentos || [])?.length > 0 ? (
                            //       <Group gap="xs">
                            //         {item
                            //           .documentos!.filter(
                            //             (x) =>
                            //               x.documentoTipo === 'Nota Fiscal' ||
                            //               x.documentoTipo === 'MTR' ||
                            //               x.documentoTipo === 'Romaneio de Coleta'
                            //           )
                            //           .map((y) => {
                            //             return (
                            //               <Badge
                            //                 key={newGuid()}
                            //                 variant="outline"
                            //               >{`${y.documentoTipo} - ${y.numeroDocumento}`}</Badge>
                            //             );
                            //           })}
                            //       </Group>
                            //     ) : (
                            //       <>-</>
                            //     );
                            //   },
                            // },
                            // {
                            //   title: 'Medição',
                            //   key: 'medicao',
                            //   render: (row: Statement) => {
                            //     const quantidadeOrigem = row.medicao.quantidadeOrigem
                            //       ? `${row.medicao.quantidadeOrigem} ${row.medicao.quantidadeOrigemUnidadeMedida}`
                            //       : null;
                            //     const quantidadeDestino = row.medicao.quantidadeDestino
                            //       ? `${row.medicao.quantidadeDestino} ${row.medicao.quantidadeDestinoUnidadeMedida}`
                            //       : null;
                            //     const tempo = row.medicao.tempo
                            //       ? `${row.medicao.tempo} ${row.medicao.tempoUnidadeMedida}`
                            //       : null;
                            //     const minimoAceitavel =
                            //       row.residuo && row.residuo.minimoAceitavelIdUnidadeMedida1
                            //         ? `${row.residuo.minimoAceitavel} ${row.residuo.minimoAceitavelUnidadeMedida1} / ${row.residuo.minimoAceitavelUnidadeMedida2}`
                            //         : null;

                            //     return (
                            //       <Stack gap="xs">
                            //         {quantidadeOrigem && <div>{`Quantidade Origem: ${quantidadeOrigem}`}</div>}
                            //         {quantidadeDestino && <div>{`Quantidade Destino: ${quantidadeDestino}`}</div>}
                            //         {tempo && <div>{`Tempo Coleta: ${tempo}`}</div>}
                            //         {minimoAceitavel && <div>{`Mínimo Aceitável: ${minimoAceitavel}`}</div>}
                            //       </Stack>
                            //     );
                            //   },
                            // },
                            // {
                            //   title: 'Quantidade (Origem)',
                            //   key: 'quantidadeOrigem',
                            //   render: (row: Statement) =>
                            //     row.medicao.quantidadeOrigem
                            //       ? `${row.medicao.quantidadeOrigem} ${row.medicao.quantidadeOrigemUnidadeMedida}`
                            //       : '-',
                            // },
                            // {
                            //   title: 'Quantidade (Destino)',
                            //   key: 'quantidadeDestino',
                            //   render: (row: Statement) =>
                            //     row.medicao.quantidadeDestino
                            //       ? `${row.medicao.quantidadeDestino} ${row.medicao.quantidadeDestinoUnidadeMedida}`
                            //       : '-',
                            // },
                            // {
                            //   title: 'Mínimo Aceitável',
                            //   key: 'minimoAceitavel',
                            //   render: (row: Statement) =>
                            //     row.residuo && row.residuo.minimoAceitavelIdUnidadeMedida1
                            //       ? `${row.residuo.minimoAceitavel} ${row.residuo.minimoAceitavelUnidadeMedida1} / ${row.residuo.minimoAceitavelUnidadeMedida2}`
                            //       : '-',
                            // },
                            {
                              title: 'Cliente / Receita',
                              key: 'idCliente',
                              sorter: (a: Statement, b: Statement) =>
                                (
                                  a.cliente.nomeFantasia ||
                                  a.cliente.razaoSocial ||
                                  a.cliente.nome ||
                                  ''
                                ).localeCompare(
                                  b.cliente.nomeFantasia || b.cliente.razaoSocial || b.cliente.nome || ''
                                ),
                              render: (row: Statement) => {
                                return row.cliente.cnpj ? (
                                  <ProfileCardLink
                                    id={row.cliente.idEntidade.toString()}
                                    name={row.cliente.nomeFantasia || row.cliente.razaoSocial || '-'}
                                    nameSize="sm"
                                    description={formatCurrency(row.movimentacao.receita)}
                                    descriptionSize="xs"
                                    linkPrefix="entities"
                                    showLink
                                  />
                                ) : (
                                  <ProfileCardLink
                                    id={row.cliente.idEntidade.toString()}
                                    name={row.cliente.nome || '-'}
                                    nameSize="sm"
                                    description={formatCurrency(row.movimentacao.receita)}
                                    descriptionSize="xs"
                                    linkPrefix="entities"
                                    showLink
                                  />
                                );
                              },
                            },
                            // {
                            //   title: 'Cliente (Valor)',
                            //   key: 'receita',
                            //   sorter: (a: Statement, b: Statement) => {
                            //     const aValue = a.movimentacao.receita || 0;
                            //     const bValue = b.movimentacao.receita || 0;
                            //     if (aValue === bValue) {
                            //       return 0;
                            //     }
                            //     return aValue > bValue ? 1 : -1;
                            //   },
                            //   render: (row: Statement) => <div>{formatCurrency(row.movimentacao.receita)}</div>,
                            // },
                            {
                              title: 'Fornecedor / Despesa',
                              key: 'idFornecedor',
                              sorter: (a: Statement, b: Statement) =>
                                (
                                  a.fornecedor.nomeFantasia ||
                                  a.fornecedor.razaoSocial ||
                                  a.fornecedor.nome ||
                                  ''
                                ).localeCompare(
                                  b.fornecedor.nomeFantasia ||
                                    b.fornecedor.razaoSocial ||
                                    b.fornecedor.nome ||
                                    ''
                                ),
                              render: (row: Statement) => {
                                if (!row.fornecedor.idEntidade) {
                                  return '-';
                                }
                                return row.fornecedor.cnpj ? (
                                  <ProfileCardLink
                                    id={row.fornecedor.idEntidade.toString()}
                                    name={row.fornecedor.nomeFantasia || row.fornecedor.razaoSocial || '-'}
                                    nameSize="sm"
                                    description={formatCurrency(row.movimentacao.despesa)}
                                    descriptionSize="xs"
                                    linkPrefix="entities"
                                    showLink
                                  />
                                ) : (
                                  <ProfileCardLink
                                    id={row.fornecedor.idEntidade.toString()}
                                    name={row.fornecedor.nome || '-'}
                                    nameSize="sm"
                                    description={formatCurrency(row.movimentacao.despesa)}
                                    descriptionSize="xs"
                                    linkPrefix="entities"
                                    showLink
                                  />
                                );
                              },
                            },
                            // {
                            //   title: 'Fornecedor (Valor)',
                            //   key: 'despesa',
                            //   sorter: (a: Statement, b: Statement) => {
                            //     const aValue = a.movimentacao.despesa || 0;
                            //     const bValue = b.movimentacao.despesa || 0;
                            //     if (aValue === bValue) {
                            //       return 0;
                            //     }
                            //     return aValue > bValue ? 1 : -1;
                            //   },
                            //   render: (row: Statement) => <div>{formatCurrency(row.movimentacao.despesa)}</div>,
                            // },
                            {
                              title: 'Data',
                              key: 'data',
                              sorter: (a: Statement, b: Statement) =>
                                new Date(a.data).valueOf() - new Date(b.data).valueOf(),
                              render: (row: Statement) => (
                                <Badge variant="outline">{formatDateToString(row.data)}</Badge>
                              ),
                              width: '120px',
                            },
                          ]}
                          rowKey="key"
                          expandable={{
                            // eslint-disable-next-line react/no-unstable-nested-components
                            expandedRowRender: (item2) => {
                              return (
                                <Paper shadow="xs" p="md" withBorder>
                                  <PageSection
                                    size="md"
                                    color={Feature.Home.Event.color}
                                    label="Medições"
                                    text=""
                                  />
                                  <Space h="md" />
                                  <Grid columns={4}>
                                    <Grid.Col span={1}>
                                      <PageViewProperty
                                        label="Quantidade de Origem"
                                        text={
                                          item2.medicao.quantidadeOrigem
                                            ? `${item2.medicao.quantidadeOrigem} ${item2.medicao.quantidadeOrigemUnidadeMedida}`
                                            : '-'
                                        }
                                        size="sm"
                                      />
                                    </Grid.Col>
                                    <Grid.Col span={1}>
                                      <PageViewProperty
                                        label="Quantidade de Destino"
                                        text={
                                          item2.medicao.quantidadeDestino
                                            ? `${item2.medicao.quantidadeDestino} ${item2.medicao.quantidadeDestinoUnidadeMedida}`
                                            : '-'
                                        }
                                        size="sm"
                                      />
                                    </Grid.Col>
                                    <Grid.Col span={1}>
                                      <PageViewProperty
                                        label="Mínimo Aceitável"
                                        text={
                                          item2.cotacao.minimoAceitavel
                                            ? `${item2.cotacao.minimoAceitavel} ${item2.cotacao.minimoAceitavelUnidadeMedida} / ${item2.cotacao.frequenciaUnidadeMedida}`
                                            : item2.residuo && item2.residuo.minimoAceitavelIdUnidadeMedida1
                                            ? `${item2.residuo.minimoAceitavel} ${item2.residuo.minimoAceitavelUnidadeMedida1} / ${item2.residuo.minimoAceitavelUnidadeMedida2}`
                                            : '-'
                                        }
                                        size="sm"
                                      />
                                    </Grid.Col>
                                    <Grid.Col span={1}>
                                      <PageViewProperty
                                        label="Tempo de Coleta/Serviço"
                                        text={
                                          item2.medicao.tempo
                                            ? `${item2.medicao.tempo} ${item2.medicao.tempoUnidadeMedida}`
                                            : '-'
                                        }
                                        size="sm"
                                      />
                                    </Grid.Col>
                                  </Grid>
                                </Paper>
                              );
                            },
                          }}
                          pagination={{
                            locale: { items_per_page: 'página' },
                            pageSizeOptions: [10, 25, 50],
                            showSizeChanger: true,
                            showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
                          }}
                        />
                      </Paper>
                    </Paper>
                  );
                },
              }}
              pagination={{
                locale: { items_per_page: 'página' },
                pageSizeOptions: [10, 25, 50],
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
              }}
            />
          </Paper>
        </div>
      )}
    </div>
  );
}
